import {statuspageCmdService, statuspageQueryService} from '../index'

class Statuspage {
    createStatuspage = data => statuspageCmdService.post('statuspage', data)
    getDomainCname = domain => statuspageQueryService.get(`domain/${domain}/cname`)
    getStatuspages = () => statuspageQueryService.get('statuspages')
    getStatuspage = id => statuspageQueryService.get(`statuspage/${id}/unified`)
    changeStatus = (id, enabled) => statuspageCmdService.put(`statuspage/${id}/status`, {enabled})
    updateStatuspage = (id, data) => statuspageCmdService.put(`statuspage/${id}`, data)
    deleteStatuspage = id => statuspageCmdService.delete(`statuspage/${id}`)
    getStatuspageComponents = id => statuspageQueryService.get(`statuspage/${id}/components`)
    getComponentIncidents = id => statuspageQueryService.get(`component/${id}/incidents`)
    createIncident = (id, data) => statuspageCmdService.post(`component/${id}/incident`, data)
    updateIncident = (id, incidentId, data) => statuspageCmdService.put(`component/${id}/incident/${incidentId}`, data)
    getStatuspageSubscriptions = (id, query) => statuspageQueryService.get(`statuspage/${id}/subscriptions${query}`)
}

export default new Statuspage()
